import { Fragment } from "react";
import StandingList from "~pages/Standings/components/StandingList";
import type { StandingTransformed } from "~pages/Standings/types/standingTransformed";
import type { TransformedResult } from "~pages/Standings/types/transformedResult";
import { sortNestedTables } from "~pages/Standings/utilities/sortNestedTables";

type Props = {
  pools: TransformedResult<StandingTransformed>[];
  selectedColumns: string[];
};

const StandingsPool = ({ pools, selectedColumns }: Props) => {
  const sortedPools = pools?.sort((poolA, poolB) => sortNestedTables(poolA, poolB));

  return (
    <span style={{ display: "flex", flexDirection: "column", gap: 10 }}>
      {sortedPools?.map((poolResult) => (
        <Fragment key={poolResult.entity?.id}>
          <StandingList title={poolResult.entity?.name} selectedColumns={selectedColumns} data={poolResult.values} />
        </Fragment>
      ))}
    </span>
  );
};

export default StandingsPool;
